import { render, staticRenderFns } from "./DocumentRequestTemplate.vue?vue&type=template&id=27d4034c&lang=pug"
import script from "./DocumentRequestTemplate.vue?vue&type=script&lang=js"
export * from "./DocumentRequestTemplate.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequestTemplate.vue?vue&type=style&index=0&id=27d4034c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports